<template>
    <md-button
        title="Generate Excel"
        class="md-info md-just-icon md-round"
        @click.stop="handleGenerateExcel(customerInvoiceId)"
    >
        <md-icon>get_app</md-icon>
    </md-button>
</template>

<script>
import { GeneralMixin } from '@/mixins/GeneralMixin';
import { handleRequests, showErrorMessage, downloadFile } from '@/helpers';

export default {
    name: 'GenerateExcelButton',
    props: {
        customerInvoiceId: {
            type: [Number, String],
            default: () => null
        }
    },
    mixins: [GeneralMixin],
    methods: {
        async handleGenerateExcel(customerInvoiceId) {
            this.$_handleLoaderState(true, 'GENERATING...');
            const payload = {
                method: 'get',
                responseType: 'blob'
            };
            const api = `/api/customer-invoices/${customerInvoiceId}/download/excel`;

            try {
                const response = await handleRequests(api, payload);
                await downloadFile(response.data, 'invoiceData.xlsx');
                this.$notify({
                    message: 'Successfully downloaded the invoice data.',
                    type: 'success'
                });
                this.$emit('invoiceGenerated', true);
            } catch (e) {
                const message = 'Error in generating excel.';
                showErrorMessage(this, message, e);
            }
            this.$_handleLoaderState(false);
        }
    }
};
</script>
